import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import { thunk as thunkMiddleware } from "redux-thunk";
// import { composeWithDevTools } from "redux-devtools-extension";
import { createBrowserHistory } from "history";
import { Router, Route, Redirect, Switch } from "react-router-dom";

// Libs
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";

import reducer from "./reducers";

// Components
import NotFound from "./components/NotFound";
import Header from "./components/Header";
import Home from "./components/Home";

import "./index.css";

const history = createBrowserHistory();

function configureStore(initialState) {
  if (process.env.NODE_ENV === "production") {
    const middleware = applyMiddleware(thunkMiddleware);
    const enhancer = compose(middleware);
    return createStore(reducer, initialState, enhancer);
  }
  const middleware = applyMiddleware(thunkMiddleware);
  // const enhancer = composeWithDevTools(middleware);
  const enhancer = compose(middleware);
  return createStore(reducer, initialState, enhancer);
}
const store = configureStore({});
const theme = createTheme();

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <Router history={history}>
        <div>
          <Header />
          <div className="mainContainerOuter">
            <div className="mainContainer">
              <Switch>
                <Redirect exact from="/" to="/schedule" />
                <Route exact path="/" component={Home} />
                <Route exact path="/schedule/#follow-up" component={Home} />
                <Route exact path="/schedule/" component={Home} />
                <Route
                  exact
                  path={["/schedule/phone-visit", "/schedule/phone-visit/"]}
                  component={Home}
                />
                <Route component={NotFound} />
              </Switch>
            </div>
          </div>
        </div>
      </Router>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById("root")
);
